export default "__VITE_ASSET__4fE8LPlC__"